/* eslint-disable */
import React from 'react';
import { NavLink, useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useRegionalLink } from 'hooks/useRegionalLink';

import { Company } from 'components/common/Elements/Elements';

import { recordType } from 'utils/common';

const Account = ({ company }) => {
  let { url } = useRouteMatch();
  const generateRegionalPath = useRegionalLink();
  const {
    customerId,
    companyName,
    status,
    companySize,
    country,
    website,
    poc
  } = company;

  return (
    <NavLink to={generateRegionalPath(`/mobile/team/${company.customerId}`)}>
      <Company
        nameCompany={companyName ? companyName : customerId}
        status={status}
        description={companySize}
        recordType={recordType(company)}
        country={country}
        domain={website}
        addStatus={poc}
        customerId={customerId}
      />
    </NavLink>
  );
};

Account.propTypes = {
  company: PropTypes.object
};

export default Account;
